import * as actions from './actions'

export type State = {
  [key: string]: {
    file: any;
    progress?: number;
    success?: boolean;
    error?: any;
    objectId?: string;
  };
};

export const initialState: Record<string, any> = {}

const reducer = (state: State, action: any) => {
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case actions.UPLOAD_STARTED:
    case actions.UPLOAD_REQUEST:
      return {
        ...state,
        [action.key]: {
          file: action.file,
          objectId: action.objectId,
          progress: 0,
          error: undefined,
          success: undefined,
        }
      }
    case actions.UPLOAD_PROGRESS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          progress: action.progress
        }
      }
    case actions.UPLOAD_FAILURE:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          success: false,
          error: action.error
        }
      }
    case actions.UPLOAD_SUCCESS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          success: true
        }
      }
    case actions.CLEAR_UPLOADS:
      const keysToClear = new Set(action.keys)
      return Object.keys(state).reduce<Record<string, any>>((acc, key) => {
        if (keysToClear.has(key)) {
          return acc
        }
        return {
          ...acc,
          [key]: state[key],
        }
      }, {})
    default:
      return state
  }
}

export default reducer
